// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"1361f5c9","256":"1e09c822","395":"e7b6fa07","455":"817cb507","659":"48576217","899":"4551c25c","977":"fd139966"}[chunkId] + ".chunk.js";
};